export enum NodeEnv {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export enum StorageType {
  SESSION = 'sessionStorage',
  LOCAL = 'localStorage',
}

export enum ServerError {
  USER_NOT_FOUND = 'User not found.',
  USER_PAGES_RUN_OUT = 'User pages ran out.',
  SERVICE_UNAVAILABLE = 'Sorry, the service is unavailable',
}

export enum LengthInChars {
  EDITOR_USER_REQUEST_MIN = 5,
  EDITOR_USER_REQUEST_MAX = 5000,
}

export enum AuthStatus {
  NOT_STARTED = 'not started',
  PENDING = 'pending',
  PASSED = 'passed',
}

export enum CookieName {
  GA = '_ga',
}

export enum GenRequestType {
  SIMPLE = 'simple',
  SMART = 'smart',
}

export enum StorageKey {
  JUST_USED_FREE_SMART_ANSWER = 'justUsedFreeSmartAnswer',
}

export enum ApiResponseStatus {
  SUCCESS = 200,
  CREATED = 201,
  ALREADY_EXIST = 302,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  SERVER_ERROR = 500,
}

export const AdsBannerSlots = {
  // Sidebar left
  SLOT_1: {
    adSlot: '5406994099',
    fullWidthResponsive: false,
    style: { display: 'inline-block', width: '250px', height: '250px' },
  },
  // Sidebar right
  SLOT_2: {
    adSlot: '7300877306',
    fullWidthResponsive: false,
    style: { display: 'inline-block', width: '250px', height: '250px' },
  },
  // Header footer
  SLOT_3: {
    adSlot: '9154667413',
    fullWidthResponsive: false,
    style: { display: 'block', width: '728px', height: '100px' },
  },
  // Header footer mobile
  SLOT_4: {
    adSlot: '9985348330',
    fullWidthResponsive: false,
    style: { display: 'block', width: '300px', height: '100px' },
  },
  // Popup left
  SLOT_5: {
    adSlot: '6907159473',
    fullWidthResponsive: false,
    style: { display: 'block', width: '280px', height: '280px' },
  },
  // Popup right
  SLOT_6: {
    adSlot: '6702434902',
    fullWidthResponsive: false,
    style: { display: 'block', width: '280px', height: '280px' },
  },
};

export const textContentSelector = 'js-text-content';

export enum LoginEventPopupFlow {
  OTHER = 'other',
}
